import AnalyticsManagerBase from "./../../../src/common/analytics/analyticsmanagerbase";
import MixpanelEngine from "./engines/MixpanelEngine";
import AnalyticsEngineER from "./../../../src/common/analytics/engines/analyticsEngineER";
import oneTrust from "./../../../src/common/cmp/oneTrust";

export default class AnalyticsManager extends AnalyticsManagerBase {
  constructor(options) {
    super(options);
    this._initEngines();
    this.cmpManager = new oneTrust(options.cmp);
    // To show the privacy options in settings, platform code expects the analyticsManager
    // to have a properties cmpManager._options.cmp where it can test for hasPreferenceView
    this.cmpManager.on("userConsent:changed", () => {
      this._initEnginesWithCMP();
      this.trigger("userConsent:changed");
    });
  }

  _initEngines() {
    this.MixpanelEngine = new MixpanelEngine(this, this._options);
  }

  _initEnginesWithCMP() {
    if (
      this.cmpManager.getConsentForCookieGroup(
        this._options.cmp.performanceCategory
      )
    ) {
      this.MixpanelEngine.subscribeToEvents();
      if (!this.ER) {
        this.ER = new AnalyticsEngineER(this, this._options);
      }
    } else {
      this.MixpanelEngine.unsubscribeFromEvents();
    }
  }
}



// WEBPACK FOOTER //
// ./clients/dmg-sco/js/analyticsManager.js